import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.GettingStartedPage.SubscriptionPlan', {
    title: 'Choose your subscription plan',
    description:
        'All plans come with unlimited seats and allow for an unlimited number of document approvals. Select from Standard, Advanced, and Premium plans.{br}{br}As you chose to use ApprovalMax to {useCase}, we recommend Advanced.',
    buttonText: 'Choose plan',
});
